import PostEditor from './editor';

export default PostEditor;
